import React from "react";
// import Header from "./header";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
// import "./slider-animations.css";
// import 'react-animated-slider/build/horizontal.css';
import { Carousel, Button } from 'antd';

const content = [
  {
    title: "Designed to make Learning",
    description: "Orsity is an Online Platform",
    button: "See pricing plan",
    button2: "Signup Now",
    image: "https://i.imgur.com/DvmN8Hx.jpg",
    // user: "Bruno Vizovskyy",
    // userProfile: "https://i.imgur.com/4KeKvtH.png"
  },
  {
    title: "Designed to make Learning",
    description: "Orsity is an Online Platform",
    button: "See pricing plan",
    button2: "Signup Now",
    image: process.env.PUBLIC_URL + '/img/2.jpg',
    // user: "Luan Gjokaj",
    // userProfile: "https://i.imgur.com/JSW6mEk.png"
  },
  {
    title: "Designed to make Learning",
    description: "Orsity is an Online Platform",
    button: "See pricing plan",
    button2: "Signup Now",
    image: process.env.PUBLIC_URL + "/img/examples-hero.jpg",
    // user: "Erich Behrens",
    // userProfile: "https://i.imgur.com/0Clfnu7.png"
  },

];

export default (props) => (
  <div className="xheader ">
    {/* <Header /> */}

    {/* <div className="banner-holder">
      <Carousel autoplay dots={false}>
        {content.map((item, index) => (
          <div
            key={index}
            className="banner-img"
          >
            <img src={`${item.image}`} alt="" />
            <div className="inner">
              <p>{item.description}</p>
              <h1>{item.title}</h1>
              <div style={{ display: "flex", textAlign: "center", justifyContent: "center" }}>
                {props.auth.isEmpty && <button onClick={() => props.history.push('/pricing')} className="xtrans">{item.button}</button>}
                {props.auth.isEmpty && <button className="blue-btn" onClick={() => props.history.push('/signup')} >{item.button2}</button>}
                {!props.auth.isEmpty && <button onClick={() => props.history.push('/courses')} className="xtrans">See all Courses</button>}
                {!props.auth.isEmpty && <button className="blue-btn" onClick={() => props.history.push('/change-plan')} >Go Pro</button>}
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div> */}

    <div className="x-home-slider">
      <Slider draggable={false} swipe={false} nextButton={false} prevButton={false}
        autoplay={3000} className="slider-wrapper">
        {content.map((item, index) => (
          <div
            key={index}
            className="slider-content"
            style={{ background: `url('${item.image}') no-repeat center center` }}
          >
            <div className="inner">
              <p>{item.description}</p>
              <h1>{item.title}</h1>
              <div style={{ display: "flex", textAlign: "center", justifyContent: "center" }}>
                {props.auth.isEmpty && <button onClick={() => props.history.push('/pricing')} className="xtrans">{item.button}</button>}
                {props.auth.isEmpty && <button className="blue-btn" onClick={() => props.history.push('/signup')} >{item.button2}</button>}
                {!props.auth.isEmpty && <button onClick={() => props.history.push('/courses')} className="xtrans">See all Courses</button>}
                {!props.auth.isEmpty && <button className="blue-btn" onClick={() => props.history.push('/change-plan')} >Go Pro</button>}
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  </div>
);